// extracted by mini-css-extract-plugin
export default {"img":"PostForm-module__img___Bjhts","textarea":"PostForm-module__textarea___qINt3"};